import React from 'react'
import PropTypes from 'prop-types'
import { Box, Icon } from '@maui/elements'

const BreadcrumbItem = ({ children, css = {}, ...props }) => (
  <Box
    as='li'
    fontSize='1'
    fontWeight='light'
    whiteSpace='nowrap'
    pr='2'
    display='flex'
    alignItems='center'
    {...props}
  >
    {children}
  </Box>
)

const Separator = ({ children, chevron, ...props }) => (
  <Box
    as='span'
    marginLeft='2'
    color={chevron ? 'colorBorderActive' : 'colorBorderEmphasis'}
    fontSize='12px'
    flexShrink='0'
    {...props}
  >
    {children}
    <Icon name={chevron ? 'chevron-right' : 'arrow-right'} mt="6px" />
  </Box>
)

const Breadcrumbs = ({ separator, chevron, ...props }) => {
  const children = React.Children.toArray(props.children)
  const maxItemWidth = children.length ? `${1 / children.length * 100}%` : 0

  return (
    <Box
      as='ol'
      listStyle='none'
      display='flex'
      alignItems='center'
      margin='0'
      marginBottom='-10px'
      padding='0'
    >
      {children.reduce((memo, child, i) => {
        memo.push(
          <BreadcrumbItem
            key={i}
            css={{ maxWidth: maxItemWidth }}
          >
            {child}
            {i < children.length - 1 && <Separator chevron={chevron} />}
          </BreadcrumbItem>
        )
        return memo
      }, [])}
    </Box>
  )
}

BreadcrumbItem.propTypes = {
  children: PropTypes.node,
  css: PropTypes.object,
}

Separator.propTypes = {
  children: PropTypes.node
}

Breadcrumbs.propTypes = {
  children: PropTypes.node,
  separator: PropTypes.node
}

export default Breadcrumbs
